import { observer } from "mobx-react-lite";

import ChangeOrderOrSubscription from "../ChangeOrderOrSubscription";
import BurgerMenuAndCart from "./BurgerMenuAndCart";
import MobileSearchBar from "./MobileSearchBar";

const MobileHeader = () => {
   return (
      <>
         <BurgerMenuAndCart />
         <MobileSearchBar />
         <ChangeOrderOrSubscription />
      </>
   );
};

export default observer(MobileHeader);
